export function isNearValue(value: number, value2: number, interval = 5) {
  return value <= value2 + interval && value > value2 - interval;
}
